import styled from 'styled-components';
import { Flex } from '@bookjane2/bookjane-design-library';

export const CustomerLocationsModalHeader = styled(Flex)`
  flex-direction: column;
  gap: 8px;
  padding: 32px;
  border-top: 1px solid ${({ theme }) => theme.colors.Grey4};
`;

export const CustomerLocationsModalTitle = styled.h3`
  ${({ theme }) => theme.fonts.PoppinsSemiBold};
  font-size: 28px;
  font-weight: 600;
  line-height: 32px;
  color: ${({ theme }) => theme.colors.TextDarkGrey};
`;

export const CustomerLocationsModalSubtitle = styled.h3`
  ${({ theme }) => theme.fonts.PoppinsText};
  font-size: 14px;
  font-weight: 600;
  line-height: 21px;
  color: ${({ theme }) => theme.colors.TextSubtleGrey};
  margin: 0;
`;

export const LocationSection = styled(Flex)`
  flex-direction: column;
  padding: 32px;
`;

export const LocationDivider = styled.div`
  height: 1px;
  background-color: ${({ theme }) => theme.colors.Grey4};
  width: 100%;
`;

export const LocationTitle = styled.h4`
  ${({ theme }) => theme.fonts.PoppinsSemiBold};
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.TextDarkGrey};
  margin-bottom: 32px;
`;

export const LocationDetailsTitle = styled.h5`
  ${({ theme }) => theme.fonts.PoppinsSemiBold};
  font-size: 14px;
  font-weight: 600;
  line-height: 21px;
  color: ${({ theme }) => theme.colors.TextDarkGrey};
  margin-bottom: 16px;
`;

export const LocationDetails = styled(Flex)`
  flex-direction: column;
  gap: 16px;
`;

export const LocationDetailsRow = styled(Flex)`
  flex-direction: row;
  gap: 32px;
  align-items: flex-start;
`;

export const LocationDetailsColumn = styled(Flex)`
  flex-direction: column;
  gap: 12px;
  flex: 1;
`;

export const ContactInformationTitle = styled.h5`
  ${({ theme }) => theme.fonts.PoppinsSemiBold};
  font-size: 14px;
  font-weight: 600;
  line-height: 21px;
  color: ${({ theme }) => theme.colors.TextDarkGrey};
  margin: 16px 0 12px 0;
`;

export const ContactInformationContainer = styled(Flex)`
  flex-direction: column;
  gap: 16px;
`;

export const ContactInformationRow = styled(Flex)`
  flex-direction: row;
  gap: 32px;
  align-items: flex-start;
`;

export const ContactInformationColumn = styled(Flex)`
  flex-direction: column;
  gap: 12px;
  flex: 1;
`;

export const ContactDetailRow = styled(Flex)`
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 8px;
`;

export const ContactDetailLabel = styled.span`
  ${({ theme }) => theme.fonts.PoppinsText};
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.TextDarkGrey};
  min-width: 120px;
  flex-shrink: 0;
`;

export const ContactDetailValue = styled.span`
  ${({ theme }) => theme.fonts.PoppinsText};
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.TextDarkGrey};
  flex: 1;
  word-break: break-word;
`;

export const LocationDetailRow = styled(Flex)`
  flex-direction: column;
  gap: 4px;
`;

export const LocationDetailLabel = styled.span`
  ${({ theme }) => theme.fonts.PoppinsText};
  font-size: 14px;
  font-weight: 600;
  line-height: 21px;
  color: ${({ theme }) => theme.colors.TextDarkGrey};
`;

export const LocationDetailValue = styled.span`
  ${({ theme }) => theme.fonts.PoppinsText};
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.TextDarkGrey};
  word-break: break-word;
  margin-left: 16px;
`;

export const EditButtonWrapper = styled(Flex)`
  justify-content: flex-end;
  padding: 24px;
  border-top: 1px solid ${({ theme }) => theme.colors.Grey4};
  background-color: white;
  position: sticky;
  bottom: 0;
`;

export const EditButton = styled.button`
  background: white;
  border: 1px solid ${({ theme }) => theme.colors.PrimaryDefault};
  color: ${({ theme }) => theme.colors.PrimaryDefault};
  padding: 12px 32px;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${({ theme }) => theme.colors.PrimaryDefault};
    color: white;
  }
`;
